export const APP_CARD_OPTION = 'AppCardOption';
